import { Injectable } from '@angular/core';
import { LessonPageItemProgressLocal } from '../../data/interfaces/LessonPageItemProgressLocal';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {}

  get<T>(key: string): T | null {
    const raw = localStorage.getItem(key);
    try {
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.error(`Error parsing localStorage key "${key}"`, e);
      return null;
    }
  }

  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Error saving to localStorage key "${key}"`, e);
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }

  getLessonItemProgress(): LessonPageItemProgressLocal[] {
    return this.get<LessonPageItemProgressLocal[]>('lessonItemProgress') || [];
  }
  
  setLessonItemProgress(progress: LessonPageItemProgressLocal[]): void {
    this.set('lessonItemProgress', progress);
  }
}